<template>
  <v-container>
    <v-layout justify-center align-center>
      <v-flex md8>
        <v-card elevation="3">
          <v-card-text>
            <v-form ref="form">
                <v-row dense class="pa-5">
                <v-col cols="6">
                    <v-text-field
                        v-model="send.email"
                        label="Correo"
                        :rules="fieldRequired"
                        outlined
                        dense/>
                </v-col>
                <v-col cols="6">
                    <v-text-field
                        v-model="send.name"
                        label="Nombre"
                        :rules="fieldRequired"
                        outlined
                        dense/>
                </v-col>
                <v-col cols="12">
                    <v-text-field
                        v-model="send.message"
                        label="Mensaje de prueba"
                        :rules="fieldRequired"
                        outlined
                        dense/>
                </v-col>
                </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-layout justify-end>
              <v-btn class="green darken-1 mr-3" dark outlined @click="sendDataTest">
                <v-icon left> mdi-cloud-upload </v-icon>Enviar
              </v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { Validate } from '@/mixins/validateFormMixin'
export default {
  mixins: [Validate],
  data: () => ({
    send: {
      email: '',
      message: ''
    }
  }),
  components: {},
  methods: {
    ...mapActions(['urlPostServicesAction']),
    sendDataTest () {
      if (this.$refs.form.validate()) {
        const router = this.get_urls['inventario.send-email']
        this.urlPostServicesAction({ url: router, data: this.send })
      }
    }
  },
  computed: {
    ...mapGetters(['get_urls', 'get_object'])
  },
  watch: {
    typeImport () {
      this.results = null
      this.chosenFile = null
      this.message = ''
    },
    get_object (val) {
      if (val.message) {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error!',
          text: val.message
        })
        return
      }
      this.$swal({
        type: 'success',
        icon: 'success',
        title: 'Exitoso!',
        text: 'Importacion realizada correctamente'
      })
    }
  }
}
</script>

<style>

</style>
